import React from "react";
import ReactDOM from "react-dom/client";
import "./polyfills";
import "@/index.css";
import App from "@/App";
import { installClientErrorReporting, reportClientError } from "@/services/clientErrorReporter";

installClientErrorReporting();

function BootRecovery({ canRetry = false, staleBuild = false }) {
  const retry = () => {
    if (staleBuild) window.__slotsHardRefresh?.();
    else window.location.reload();
  };
  return (
    <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24, background: '#001739', color: '#fff', textAlign: 'center' }}>
      <section style={{ maxWidth: 360 }}>
        <h1 style={{ margin: '0 0 10px', color: '#f5d76e', fontSize: 24 }}>{canRetry ? 'Slots Oceans could not finish loading' : 'Refreshing Slots Oceans'}</h1>
        <p style={{ margin: '0 0 18px', color: 'rgba(255,255,255,.8)', lineHeight: 1.5 }}>{canRetry ? (staleBuild ? 'Tap below to repair the saved app files and open the latest version.' : 'Tap below to reload and try again.') : 'Getting the latest secure version for you.'}</p>
        {canRetry ? (
          <button type="button" onClick={retry} style={{ border: 0, borderRadius: 12, padding: '13px 20px', background: '#f5d76e', color: '#001739', fontWeight: 800 }}>{staleBuild ? 'Repair and open Slots Oceans' : 'Reload Slots Oceans'}</button>
        ) : null}
      </section>
    </main>
  );
}

class AppBootBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false, canRetry: false, staleBuild: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidMount() {
    this.stableTimer = window.setTimeout(() => {
      try { window.sessionStorage.removeItem('slots_frontend_recovery_v1'); } catch {}
      try {
        const current = new URL(window.location.href);
        if (current.searchParams.has('__app_refresh')) {
          current.searchParams.delete('__app_refresh');
          window.history.replaceState(window.history.state, '', `${current.pathname}${current.search}${current.hash}`);
        }
      } catch {}
    }, 15000);
  }

  componentWillUnmount() {
    if (this.stableTimer) window.clearTimeout(this.stableTimer);
  }

  componentDidCatch(error, info) {
    reportClientError({
      source: 'frontend',
      message: error?.message || 'Application boot failed',
      stack: [error?.stack, info?.componentStack].filter(Boolean).join('\n'),
      component: 'AppBootBoundary',
      code: error?.name || 'APP_BOOT_FAILED',
    });
    // Only purge caches and auto-reload for missing/expired build assets.
    // A normal React exception is deterministic and reloading it creates a
    // recovery loop that incorrectly blames the customer's saved browser app.
    if (window.__slotsIsStaleBuildError?.(error)) {
      this.setState({ staleBuild: true });
      window.__slotsShowBootRecovery?.();
      const started = window.__slotsRecoverStaleBuild?.();
      if (!started) this.setState({ canRetry: true, staleBuild: true });
    } else {
      this.setState({ canRetry: true, staleBuild: false });
    }
    // eslint-disable-next-line no-console
    console.error('Application boot failed', error);
  }

  render() {
    return this.state.failed ? <BootRecovery canRetry={this.state.canRetry} staleBuild={this.state.staleBuild} /> : this.props.children;
  }
}

const rootNode = document.getElementById("root");
if (rootNode) {
  rootNode.setAttribute('data-slots-react-ready', 'true');
  ReactDOM.createRoot(rootNode).render(
    <React.StrictMode>
      <AppBootBoundary><App /></AppBootBoundary>
    </React.StrictMode>,
  );
} else {
  window.__slotsShowBootRecovery?.();
}
